import Icon from "../../../components/AppIcon";
import { Link } from "react-router-dom";
import { KnowtranLogo } from "../../../constants/images";

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  const footerSections = {
    product: {
      title: "Product",
      links: [
        { name: "Features", href: "#features" },
        { name: "Pricing", href: "#demo-booking" },
        { name: "Mobile Apps", href: "#demo-booking" },
      ],
    },
    solutions: {
      title: "Solutions",
      links: [
        { name: "K-12 Schools", href: "#demo-booking" },
        { name: "Colleges & Universities", href: "#demo-booking" },
        { name: "International Schools", href: "#demo-booking" },
        { name: "Boarding Schools", href: "#demo-booking" },
        { name: "Vocational Institutes", href: "#demo-booking" },
      ],
    },

    support: {
      title: "Support",
      links: [
        { name: "Book Demo", href: "#demo-booking" },
        { name: "Contact Us", href: "#demo-booking" },
        { name: "Get Started", href: "#demo-booking" },
      ],
    },
    company: {
      title: "Company",
      links: [
        { name: "About Us", href: "#overview" },
        { name: "Contact Us", href: "#demo-booking" },
      ],
    },
  };

  const socialLinks = [
    {
      name: "LinkedIn",
      icon: "Linkedin",
      href: "#linkedin",
      color: "text-blue-600",
    },
    {
      name: "Twitter",
      icon: "Twitter",
      href: "#twitter",
      color: "text-blue-400",
    },
    {
      name: "Facebook",
      icon: "Facebook",
      href: "#facebook",
      color: "text-blue-700",
    },
    {
      name: "YouTube",
      icon: "Youtube",
      href: "#youtube",
      color: "text-red-600",
    },
    {
      name: "Instagram",
      icon: "Instagram",
      href: "#instagram",
      color: "text-pink-600",
    },
  ];

  /*   const certifications = [
    { name: "GDPR Compliant", icon: "Shield", color: "text-success" },
    { name: "ISO 27001", icon: "Award", color: "text-primary" },
    { name: "SOC 2 Type II", icon: "CheckCircle", color: "text-accent" },
    { name: "AWS Partner", icon: "Cloud", color: "text-warning" },
  ];
 */
  const contactInfo = {
    headquarters: {
      title: "Global Headquarters",
      address: "2782+JGC",
      city: "Thenpothai, Tenkasi, Tamilnadu",
      country: "India",
      phone: "+91 9150080348",
      email: "development@insytix.com",
    },
    support: {
      title: "24/7 Support",
      phone: "+91 9150080348",
      email: "development@insytix.com",
      hours: "Available 24/7 for Enterprise customers",
    },
  };

  return (
    <footer className="bg-gradient-to-b from-surface to-background border-t border-border">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 sm:py-14 lg:py-16">
        <div className="grid lg:grid-cols-6 gap-6 sm:gap-8">
          {/* Company Info & Logo */}
          <div className="lg:col-span-2 space-y-5 sm:space-y-6">
            <div className="flex items-center space-x-2.5 sm:space-x-3">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center">
                <img
                  src={KnowtranLogo}
                  alt="KnowTran"
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
            <p className="font-inter font-500 text-sm sm:text-base text-muted-foreground leading-relaxed">
              Transforming educational institutions worldwide with intelligent
              management solutions. Built with advanced features and seamless
              implementation.
            </p>
            {/* Contact Information */}
            <div className="space-y-3.5 sm:space-y-4">
              <div>
                <h4 className="font-jakarta font-700 text-base sm:text-lg text-foreground mb-1.5 sm:mb-2">
                  {contactInfo?.headquarters?.title}
                </h4>
                <div className="space-y-0.5 sm:space-y-1 text-xs sm:text-sm font-inter font-500 text-muted-foreground">
                  <div>{contactInfo?.headquarters?.address}</div>
                  <div>{contactInfo?.headquarters?.city}</div>
                  <div>{contactInfo?.headquarters?.country}</div>
                </div>
              </div>

              <div className="flex flex-col space-y-1.5 sm:space-y-2">
                <a
                  href={`tel:${contactInfo?.headquarters?.phone}`}
                  className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors duration-300"
                >
                  <Icon name="Phone" size={16} color="currentColor" />
                  <span className="font-inter font-600 text-sm sm:text-base">
                    {contactInfo?.headquarters?.phone}
                  </span>
                </a>

                <a
                  href={`mailto:${contactInfo?.headquarters?.email}`}
                  className="inline-flex items-center space-x-2 text-primary hover:text-primary/80 transition-colors duration-300"
                >
                  <Icon name="Mail" size={16} color="currentColor" />
                  <span className="font-inter font-600 text-sm sm:text-base">
                    {contactInfo?.headquarters?.email}
                  </span>
                </a>
              </div>
            </div>

            {/* Social Links */}
            <div>
              <h4 className="font-jakarta font-700 text-base sm:text-lg text-foreground mb-3 sm:mb-4">
                Follow Us
              </h4>
              <div className="flex space-x-3 sm:space-x-4">
                {socialLinks?.map((social) => (
                  <a
                    key={social?.name}
                    href={social?.href}
                    className={`w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-white/60 backdrop-blur-sm border border-white/20 flex items-center justify-center hover:shadow-lg transition-all duration-300 ${social?.color} hover:scale-110`}
                    aria-label={social?.name}
                  >
                    <Icon name={social?.icon} size={18} color="currentColor" />
                  </a>
                ))}
              </div>
            </div>

            {/* App Store & Play Store Badges */}
            <div className="mt-5 sm:mt-6">
              <h4 className="font-jakarta font-700 text-base sm:text-lg text-foreground mb-3 sm:mb-4">
                Download Our App
              </h4>
              <div className="flex space-x-2.5 sm:space-x-3 items-center">
                <a
                  href="https://apps.apple.com/in/app/knowtran/id6746741555"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-80 transition-opacity duration-300"
                >
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="Download on the App Store"
                    className="h-9 sm:h-10 w-auto"
                  />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=com.xbi4.knowtran_app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-80 transition-opacity duration-300"
                >
                  <img
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                    alt="Get it on Google Play"
                    className="h-[52px] sm:h-[60px] w-auto"
                  />
                </a>
              </div>
            </div>
          </div>

          {/* Footer Links */}
          {Object.entries(footerSections)?.map(([key, section]) => (
            <div key={key} className="space-y-3.5 sm:space-y-4 ">
              <h4 className="font-jakarta font-700 text-base sm:text-lg text-foreground">
                {section?.title}
              </h4>
              <ul className="space-y-2.5 sm:space-y-3">
                {section?.links?.map((link) => (
                  <li key={link?.name}>
                    <a
                      href={link?.href}
                      className="font-inter font-500 text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
                    >
                      {link?.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter Signup */}
        {/* <div className="mt-16 pt-8 border-t border-border">
          <div className="bg-gradient-to-r from-primary/10 to-secondary/10 rounded-2xl p-8 border border-primary/20">
            <div className="grid lg:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="font-jakarta font-700 text-2xl text-foreground mb-4">
                  Stay Updated with KnowTran
                </h3>
                <p className="font-inter font-500 text-muted-foreground">
                  Get the latest updates on new features, educational insights,
                  and industry best practices delivered to your inbox.
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex space-x-3">
                  <input
                    type="email"
                    placeholder="Enter your email address"
                    className="flex-1 px-4 py-3 border border-border rounded-xl bg-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                  />
                  <button className="px-6 py-3 bg-primary text-white rounded-xl font-jakarta font-600 hover:bg-primary/90 transition-all duration-300 aurora-glow">
                    Subscribe
                  </button>
                </div>
                <p className="text-xs font-inter font-400 text-muted-foreground">
                  By subscribing, you agree to our Privacy Policy. Unsubscribe
                  at any time.
                </p>
              </div>
            </div>
          </div>
        </div> */}

        {/* Certifications & Trust Badges */}
        {/* <div className="mt-12 pt-8 border-t border-border">
          <div className="text-center mb-8">
            <h4 className="font-jakarta font-700 text-lg text-foreground mb-4">
              Trusted & Certified
            </h4>
            <p className="font-inter font-500 text-muted-foreground">
              Meeting the highest standards of security, privacy, and compliance
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {certifications?.map((cert) => (
              <div
                key={cert?.name}
                className="flex flex-col items-center p-4 bg-white/60 backdrop-blur-sm rounded-xl border border-white/20 hover:shadow-lg transition-all duration-300"
              >
                <Icon
                  name={cert?.icon}
                  size={32}
                  color={`var(--color-${cert?.color?.split("-")?.[1]})`}
                  className="mb-3"
                />
                <div className="font-inter font-600 text-sm text-foreground text-center">
                  {cert?.name}
                </div>
              </div>
            ))}
          </div>
        </div> */}
      </div>
      {/* Bottom Bar */}
      <div className="border-t border-border bg-surface/50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 sm:py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3.5 sm:space-y-4 md:space-y-0">
            <div className="font-inter font-500 text-xs sm:text-sm text-muted-foreground">
              © {currentYear} KnowTran Technologies. All rights reserved.
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap items-center gap-x-4 sm:gap-x-6 gap-y-1.5">
              <Link
                to="/privacy-policy"
                className="font-inter font-500 text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-of-service"
                className="font-inter font-500 text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                Terms of Service
              </Link>
              {/* <a
                href="#cookies"
                className="font-inter font-500 text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                Cookie Policy
              </a>
              <a
                href="#gdpr"
                className="font-inter font-500 text-muted-foreground hover:text-primary transition-colors duration-300"
              >
                GDPR Compliance
              </a> */}
            </div>

            {/* Language Selector */}
            {/* <div className="flex items-center space-x-2">
              <Icon
                name="Globe"
                size={16}
                color="var(--color-muted-foreground)"
              />
              <select className="bg-transparent border-none text-muted-foreground font-inter font-500 focus:outline-none cursor-pointer">
                <option value="en">English</option>
                <option value="es">Español</option>
                <option value="fr">Français</option>
                <option value="de">Deutsch</option>
                <option value="pt">Português</option>
              </select>
            </div> */}
          </div>
        </div>
      </div>
      {/* Back to Top Button */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className="fixed bottom-6 sm:bottom-8 right-6 sm:right-8 w-11 h-11 sm:w-12 sm:h-12 bg-primary text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 aurora-glow hover:scale-110 z-50"
        aria-label="Back to top"
      >
        <Icon name="ArrowUp" size={18} color="white" strokeWidth={2.5} />
      </button>
    </footer>
  );
};

export default FooterSection;
